import { render, staticRenderFns } from "./gscAuthorization.vue?vue&type=template&id=7afff94b&scoped=true"
import script from "./gscAuthorization.vue?vue&type=script&lang=js"
export * from "./gscAuthorization.vue?vue&type=script&lang=js"
import style0 from "./gscAuthorization.vue?vue&type=style&index=0&id=7afff94b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afff94b",
  null
  
)

export default component.exports